import React from 'react';
import CardPost from './CardPost.js';
import Pagination from '../Pagination.js';
import Form from '../Form.js';
import PostGrid from '../PostGrid.js';
import PostFields from '../PostFields.js';
import '../../scss/templates/card.scss';

export default (props) => {
	const data = props.data;
	const widgetModel = data.widgetModel;
	const posts = data.posts;
	const filters = data.filters;
	if ( !posts.length && !filters.length) {
		return null;
	}
	return (
		<div id={widgetModel.id} className="cdc-cc-widget cdc-cc-widget-card">
			<Form data={data} />
			{!posts.length && filters.length ? (
				<PostFields.noResults></PostFields.noResults>
			): (
				<PostGrid data={data} PostComponent={CardPost}></PostGrid>
			)}
			{widgetModel.pagination ? <Pagination data={data}></Pagination> : ''}
		</div>
	);
};
